import React, {createContext, useContext, useState} from 'react'

const Context = createContext();

export const StateContext = ({children}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [allSpeciesData, setAllSpeciesData] = useState([]);

    return (
        <Context.Provider
            value={{
                searchTerm,
                setSearchTerm,
                allSpeciesData, 
                setAllSpeciesData
            }}
        >
            {children}
        </Context.Provider>
    )
}

export const useStateContext = () => useContext(Context)